import { createSlice } from "@reduxjs/toolkit";
import { UpdateStock, GetStocks, GetStocksForSale } from "services/stock/stock.service";
import { toast } from 'react-toastify';

export const stockListSlice = createSlice({
  name: "stockList",
  initialState: {
    stockList: [],
    stockListLoading: false,
    stockListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetStocks.pending, (state) => {
      state.stockListLoading = true
    });

    builder.addCase(GetStocks.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Stock promise resolved 👌');

      state.stockList = action.payload
      state.stockListLoading = false
      state.stockListError = null
    });

    builder.addCase(GetStocks.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Stock promise rejected 🤯 😣')

      state.stockListLoading = false
      state.stockListError = action.error?.message
    });
  },
});


export const stockUpdateSlice = createSlice({
  name: "stockUpdate",
  initialState: {
    stockUpdate: {},
    stockUpdateLoading: false,
    stockUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateStock.pending, (state) => {
      // toast.loading('We are updating the stock 🤯')
      state.stockUpdateLoading = true
    });

    builder.addCase(UpdateStock.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Stock update successfully 👌');

      state.stockUpdate = action.payload
      state.stockUpdateLoading = false
      state.stockUpdateError = null
    });

    builder.addCase(UpdateStock.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the Stock 😣")

      state.stockUpdateLoading = false
      state.stockUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});


export const stockListForSaleSlice = createSlice({
  name: "stockList",
  initialState: {
    stockList: [],
    stockListLoading: false,
    stockListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetStocksForSale.pending, (state) => {
      state.stockListLoading = true
    });

    builder.addCase(GetStocksForSale.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Stock promise resolved 👌');

      state.stockList = action.payload
      state.stockListLoading = false
      state.stockListError = null
    });

    builder.addCase(GetStocksForSale.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Stock promise rejected 🤯 😣')

      state.stockListLoading = false
      state.stockListError = action.error?.message
    });
  },
});